import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import { useEffect } from 'react'

function useScrollList(listWrapper, list, styles) {
  useEffect(() => {
    if (listWrapper && list) {
      // Handle scrolling behavior
      const handlelistScroll = () => {
        if (list.scrollTop > 0) {
          listWrapper.classList.add(styles.scroll)
        } else {
          listWrapper.classList.remove(styles.scroll)
        }

        // Check if scroll reaches bottom
        if (list.scrollTop + list.clientHeight + 1 >= list.scrollHeight) {
          listWrapper.classList.remove(styles.overflow)
        } else {
          listWrapper.classList.add(styles.overflow)
        }
      }

      // Initial overflow setup
      setTimeout(() => {
        if (list.scrollHeight > list.clientHeight) {
          listWrapper.classList.add(styles.overflow)
        } else {
          listWrapper.classList.remove(styles.overflow)
        }
      }, 0)

      // Lock body scroll and set up event listener
      disableBodyScroll(list, { reserveScrollBarGap: true })
      list.addEventListener('scroll', handlelistScroll)

      // Clean up on unmount
      return () => {
        list.removeEventListener('scroll', handlelistScroll)
        clearAllBodyScrollLocks()
      }
    }
  }, [list, listWrapper, styles])
}

export default useScrollList
